export const GENERAL_DATE_TIME_FORMAT = 'DD-MM-YYYY HH:mm:ss';

export const colors = {
  primary: '#574CE6',
};
